module.exports = __webpack_public_path__ + "static/media/bg.2dd7606f.png";